import { render, staticRenderFns } from "./MPgg.vue?vue&type=template&id=0db93972&scoped=true"
import script from "./MPgg.vue?vue&type=script&lang=js"
export * from "./MPgg.vue?vue&type=script&lang=js"
import style0 from "./MPgg.vue?vue&type=style&index=0&id=0db93972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db93972",
  null
  
)

export default component.exports